import React, { memo } from 'react';
import classnames from 'classnames';
import { ECHART_COLOR } from '@gp/constants/echarts';
import './index.scss';

const GeneralLegend: React.FC<IGeneralLegendProps> = (props) => {
  const { value, onChange, options, style, className, ...remains } = props;

  const handleClick = (option: IGeneralLegend) => {
    const key = option?.key;
    if (!key) return;
    const newValue = {
      ...value,
      [key]: !value?.[key],
    };
    onChange?.(newValue);
  };

  const renderLegend = (
    option: IGeneralLegend,
    isActive: boolean,
    i: number,
  ) => {
    if (!option || !option?.key) return null;
    const {
      key,
      showText = true,
      showDot = true,
      showIcon = false,
      text = null,
      dotColor = '',
      icon = null,
      iconStyle = {},
    } = option;

    return (
      <div className="gp-common-customize-legend">
        {showDot && (
          <span
            className="gp-common-customize-legend-dot"
            style={{
              backgroundColor: !isActive
                ? '#ccc'
                : dotColor || ECHART_COLOR?.[i],
            }}
          ></span>
        )}
        {showIcon && icon && (
          <img
            className="gp-common-customize-legend-icon"
            style={iconStyle}
            src={icon}
            alt=""
            width="16"
            height="16"
          />
        )}
        {showText && (
          <span className="gp-common-customize-legend-name">{text}</span>
        )}
      </div>
    );
  };

  return (
    <div
      {...remains}
      style={style}
      className={classnames('gp-common-customize-legend-comp', className)}
    >
      <div className="gp-common-customize-legend-list-container">
        {options && options?.length > 0 && (
          <ul className="gp-common-customize-legend-list">
            {options?.map((option, i) => {
              const isNotClickEvent = option?.isNotClickEvent,
                    isActive = !value || !!value?.[option?.key] || !!isNotClickEvent;

              return (
                <li
                  key={i}
                  className={classnames('gp-common-customize-legend-item', {
                    active: isActive,
                    inactive: !isActive,
                    'cursor-pointer': !isNotClickEvent,
                  })}
                  onClick={(e) => {
                    if (isNotClickEvent) return;
                    e?.stopPropagation();
                    e?.preventDefault();
                    handleClick(option);
                  }}
                >
                  {renderLegend(option, isActive, i)}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};

export default memo(GeneralLegend);
